import { commons } from '@one/core'
import { CMS } from '@one/types'
import { CmsState } from './types'
import Logo = CMS.Responses.Logo
import CMSTenantTheme = CMS.CMSTenantTheme

export default {
  configuration: (
    state: CmsState,
  ): CMS.Responses.MainConfigurationQuery | null => state.configuration || null,
  logo: (state: CmsState): Logo =>
    (state.configuration && state.configuration.logo) || { img: '', alt: '', favicon: '' },
  language: (state: CmsState): string | null =>
    (state.configuration && state.configuration.lang) || null,
  theme: (state: CmsState): CMSTenantTheme | null =>
    (state.configuration && state.configuration.theme) || null,
  currency: (state: CmsState): string | null =>
    (state.configuration && state.configuration.currency) || null,
  isEnabledCartSummarySavings: (state: CmsState): boolean | null =>
    (state.configuration && state.configuration.cartSummarySavings) || null,
  productListImgSize: (state: CmsState): string | null =>
    (state.configuration && state.configuration.imgSizeOnProductList) || null,
  pragmaPayPartnerId: (state: CmsState): string | null =>
    (state.configuration && state.configuration.pragmaPayPartnerId) || null,
  pragmaInvoicesEnable: (state: CmsState): boolean | null =>
    (state.configuration && state.configuration.pragmaInvoicesEnable) || null,
  accountStaticPages: (state: CmsState): Record<string, CMS.Responses.StaticPageDto> | null =>
    state.accountStaticPages || null,
  accountDashboardStaticPage: (state: CmsState): CMS.Responses.StaticPageDto | null =>
    (state.accountStaticPages && state.accountStaticPages.dashboard) || null,
  siteSections: (state: CmsState): Record<string, CMS.SiteSections.SiteSection> | null =>
    state.siteSections || null,
  articlesListItems: (
    state: CmsState,
  ): Array<CMS.Responses.ArticleLink> | null =>
    state.articles.articlesList && state.articles.articlesList.items,
  articleBySlug: (state: CmsState) => (
    slug: string,
  ): CMS.Responses.ArticleBody => state.articles.byId[slug] || null,
  articlesTotalItems: (state: CmsState): number | null =>
    state.articles.articlesList && state.articles.articlesList.totalItems,
  articlesTotalPages: (state: CmsState): number | null =>
    state.articles.articlesList && state.articles.articlesList.totalPages,
  articlesPageSize: (state: CmsState): number | null =>
    state.articles.articlesList && state.articles.articlesList.pageSize,
  articlesPageNumber: (state: CmsState): number | null =>
    state.articles.articlesList && state.articles.articlesList.pageNumber,
  articleTagByName: (state: CmsState) => (
    name: string,
  ): CMS.Articles.Tags.ArticleTag =>
    (state.articles.articleTags && state.articles.articleTags[name]) || null,
  isArticleFillSettingsEnabled: (state: CmsState): boolean | null =>
    (state.configuration && state.configuration.articleFillSettings) || null,
  showBrandsOnMobileMenu: (state: CmsState): boolean | null =>
    (state.configuration && state.configuration.showBrandsOnMobileMenu) || null,
  isFeatureEnabled: (state: CmsState) => (key: string): boolean => {
    const featureSwitches = state.configuration && state.configuration.featureSwitches
    const feature = featureSwitches && featureSwitches[key]
    return !!(feature && (feature.enabled || feature.isEnabled))
  },
}
